import { ScreenManagerProps } from 'components/shell/ScreenManager';
import React from 'react';
import OrderList from './OrderList';

export class Subscriptions extends React.Component<ScreenManagerProps> {
	render() {
		return <OrderList {...this.props} isSubscription />;
	}
}
